import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	private readonly _prefix: string = 'geotik';

	constructor() {
	}

	set(key: string, value: string) {
		try {
			localStorage.setItem(this._getKey(key), value);
		} catch (e) {
			const keysWhiteList = [ 'mapbox', 'currentUser', 'geotikRefreshToken', 'timeZone'];

			for (let i = 0, len = localStorage.length; i < len; ++i) {
				if (keysWhiteList.every(key => localStorage.key(i)?.indexOf(key) === -1)) {
					localStorage.removeItem(localStorage.key(i));
				}
			}
			this.set(key, value);
		}
	}

	setObject(key: string, value: object) {
		const values = JSON.stringify(value);
		this.set(key, values);
	}

	get(key: string) {
		const keyWithPrefix = this._getKey(key);
		if (!localStorage.getItem(keyWithPrefix)) {
			return null;
		}
		let result;
		try {
			result = JSON.parse(localStorage.getItem(keyWithPrefix));
		} catch (e) {
			result = localStorage.getItem(keyWithPrefix)
		}
		return result;
	}

	has(key: string) {
		return this.get(key) !== null;
	}

	remove(key: string) {
		localStorage.removeItem(this._getKey(key));
	}

	private _getKey(key): string {
		return `${this._prefix}.${key}`;
	}
}
